"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNotNil = _interopRequireDefault(require("../object/isNotNil"));

var _isNotEmpty = _interopRequireDefault(require("../array/isNotEmpty"));

var _createMediaFileUrl = _interopRequireDefault(require("./createMediaFileUrl"));

var _createMediaVariantUrl = _interopRequireDefault(require("./createMediaVariantUrl"));

var _creative = require("../../constants/creative");

var _media = require("../../constants/media");

var getMediaUrlByMedia = function getMediaUrlByMedia(media) {
  var localUrl = media.localUrl,
      mediaType = media.mediaType,
      mimeType = media.mimeType,
      serverId = media.serverId,
      url = media.url,
      variants = media.variants;
  var variantUrl = undefined; // we do not want the variant for WebM since it can be transparent

  var isWebM = mediaType === _creative.MEDIA_TYPE.VIDEO && mimeType === _media.WEBM;

  if ((0, _isNotEmpty["default"])(variants) && !isWebM) {
    var acceptableVariant = variants.find(function (_ref) {
      var chunkSize = _ref.chunkSize,
          keyframeInterval = _ref.keyframeInterval;
      return !chunkSize && keyframeInterval === _media.DEFAULT_MEDIA_VARIANT_KEYFRAME_INTERVAL;
    });

    if ((0, _isNotNil["default"])(acceptableVariant)) {
      variantUrl = (0, _createMediaVariantUrl["default"])(serverId, _media.VIDEO_TRANSFORM_TYPE.TRANSCODE, acceptableVariant);
    }
  }
  /*
    the local url holds the media blob or the external scraped media url
    url gets updated with the server media url after upload
    on creative/media save, the local url is removed and the server url is used
    (this avoids having to re-download the media from the server after upload,
    and the resulting media disappearing and reappearing 'flash')
     the variant url is a transcoded media url (video only) that is better for local
    frame extraction.
     if there is not url, try making one from the serverId
  */


  return localUrl || variantUrl || url || (0, _createMediaFileUrl["default"])(serverId);
};

var _default = getMediaUrlByMedia;
exports["default"] = _default;